import { render, staticRenderFns } from "./OrderCoachManagerCard.vue?vue&type=template&id=1c86be90"
import script from "./OrderCoachManagerCard.vue?vue&type=script&lang=js"
export * from "./OrderCoachManagerCard.vue?vue&type=script&lang=js"
import style0 from "./OrderCoachManagerCard.vue?vue&type=style&index=0&id=1c86be90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports